import React from 'react';
import WidgetTitle from './WidgetTitle';
import { Card, Row } from 'react-bootstrap';

export default function NoData({ widgetTitle }) {


    return (
        <Card className="h-100" style={{ backgroundColor: '#F5F8FA', boxShadow: 'none', border: "1px solid #D6D6D6" }}>
            <Card.Body>
                <Row>
                    <WidgetTitle>{widgetTitle}</WidgetTitle>
                </Row>
                <Row className="h-75">
                    <div className="notes-content d-flex justify-content-center align-items-center ">
                        <p>This metric does not apply to this institution.</p>
                    </div>
                </Row>
            </Card.Body>
        </Card>
    );
}